import { getFilteredData ,getSortedData} from "../../../List/helper"

export const getFilteredDepartments = ({ departments, filterKey }) => {
  return getFilteredData({ data: departments, filterKey })
}
export const getSortedDepartments = ({ departments, sort }) => {
  return getSortedData({ data: departments, sort })
}